import { Select } from 'antd'
import { ProjectStatus, ProjectStatuses, projectStatusName } from '../../../../../common/constants'

type Props = {
  status: number | null | undefined
  onChange: (status: ProjectStatus) => void
}

const StatusSelector = ({ status, onChange }: Props) => {
  const options = Object.values(ProjectStatuses).map(status => ({ value: status, label: projectStatusName(status) }))

  return <Select
    value={status ?? ProjectStatuses.Unscheduled}
    options={options}
    popupMatchSelectWidth={false}
    onChange={value => onChange(value as ProjectStatus)}
    showSearch
    optionFilterProp='label'
  />
}

export default StatusSelector